<template>

  <div class="padded">
    <el-tabs type="border-card" v-model="active">

      <el-tab-pane name="table">
        <template slot="label">
          <span class="text-primary"><i class="header-icon fa fa-stopwatch">&nbsp;</i>Expiring Sites</span>
        </template>

        <expiry-table />

    </el-tab-pane>


    <el-tab-pane name="map" lazy>
      <template slot="label">
        <span class="text-primary"><i class="header-icon fa fa-map-marker">&nbsp;</i>Map</span>
      </template>

      <tenancy-expiry-map />
    </el-tab-pane>

</el-tabs>

</div>
</template>

<script>

import ExpiryTable from '@/components/property/ExpiryTable'
import TenancyExpiryMap from '@/components/maps/TenancyExpiryMap'

export default {

  components: {
    ExpiryTable,
    TenancyExpiryMap
  },

  props: {
    showGraph: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      active: 'table'
    }
  }
}
</script>
